<template>
  <div data-test-id="recent-products" :class="inContainer ? 'container container--inline container--small' : ''">
    <div
      v-if="items.length">
      <LazyCarousel
        :title="$t('product/recently-viewed')"
        :items="items">
        <template #item="{ item }">
          <LazyProductCard
            disabled-swipe
            :product="item"
            :to="getProductRoute({product: item, lang: $lang})" />
        </template>
      </LazyCarousel>

      <Btn
        color="link"
        icon-left="System/arrow-right-s-line"
        size="small"
        :to="{ name: $lang + '-recent-products' }">
        {{ $t('product/show-all-recent-products') }}
      </Btn>
    </div>
  </div>
</template>
<script setup>
import getProductRoute from '~/helpers/get-product-route'
const route = useRoute()
const { $api } = useNuxtApp()
const recentStore = useRecentStore()

useI18n(['product'])

const props = defineProps({
  exclude: {
    type: Number,
    require: false,
    default: null
  },
  inContainer: {
    type: Boolean,
    require: false,
    default: false
  }
})

const items = ref([])
const recentItems = computed(() => recentStore.items)

const getProducts = async () => {
  const cIds = await recentStore.items.map(item => {
    if (typeof item === 'object') {
      return item.cId
    }
    if (typeof item === 'number') {
      return item
    }
    return false
  })

  const data = await $api('products', {
    query: {
      c_ids: cIds.slice(0, 6).join(','),
      unshown: true,
      refer: route.name
    }
  })
  if (data) {
    items.value = data.products
    items.value = items.value
      .sort((a, b) => {
        return cIds.indexOf(a.cId) < cIds.indexOf(b.cId) ? -1 : 1
      })
      .filter(item => {
        return item.cId !== props.exclude
      })
      .slice(0, 12)
  }
}

watch(recentItems, () => {
  if (!recentItems?.value?.length) { return }
  getProducts()
}, { immediate: true })
</script>
